import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

export const useDashboardOverview = () => {
  return useQuery({
    queryKey: ['dashboard', 'overview'],
    queryFn: async () => {
      const response = await api.getDashboardOverview()
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useTodayStats = () => {
  return useQuery({
    queryKey: ['dashboard', 'today-stats'],
    queryFn: async () => {
      const response = await api.getTodayStats()
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useTodayRevenue = () => {
  return useQuery({
    queryKey: ['dashboard', 'revenue', 'today'],
    queryFn: async () => {
      const response = await api.getTodayRevenue()
      return response.data.data.revenue
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useWeekRevenue = () => {
  return useQuery({
    queryKey: ['dashboard', 'revenue', 'week'],
    queryFn: async () => {
      const response = await api.getThisWeekRevenue()
      return response.data.data.revenue
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useMonthRevenue = () => {
  return useQuery({
    queryKey: ['dashboard', 'revenue', 'month'],
    queryFn: async () => {
      const response = await api.getThisMonthRevenue()
      return response.data.data.revenue
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useRevenueTrend = (days: number = 7) => {
  return useQuery({
    queryKey: ['dashboard', 'revenue', 'trend', days],
    queryFn: async () => {
      const response = await api.getRevenueTrend(days)
      return response.data.data.trend
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useOrderStats = (days: number = 30) => {
  return useQuery({
    queryKey: ['dashboard', 'order-stats', days],
    queryFn: async () => {
      const response = await api.getOrderStats()
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useRecentOrders = (limit: number = 10) => {
  return useQuery({
    queryKey: ['dashboard', 'recent-orders', limit],
    queryFn: async () => {
      const response = await api.getRecentOrders(limit)
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useTopProducts = (limit: number = 10) => {
  return useQuery({
    queryKey: ['dashboard', 'top-products', limit],
    queryFn: async () => {
      const response = await api.getTopProducts()
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useLowStockProducts = (limit: number = 10) => {
  return useQuery({
    queryKey: ['dashboard', 'low-stock-products', limit],
    queryFn: async () => {
      const response = await api.getLowStockProducts(limit)
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useNewCustomers = (limit: number = 10) => {
  return useQuery({
    queryKey: ['dashboard', 'new-customers', limit],
    queryFn: async () => {
      const response = await api.getNewCustomers(limit)
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useProductStats = () => {
  return useQuery({
    queryKey: ['dashboard', 'product-stats'],
    queryFn: async () => {
      const response = await api.getProductStats()
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useCustomerStats = () => {
  return useQuery({
    queryKey: ['dashboard', 'customer-stats'],
    queryFn: async () => {
      const response = await api.getCustomerStats()
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useCategoryStats = () => {
  return useQuery({
    queryKey: ['dashboard', 'category-stats'],
    queryFn: async () => {
      const response = await api.getProductStats()
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useReviewStats = () => {
  return useQuery({
    queryKey: ['dashboard', 'review-stats'],
    queryFn: async () => {
      const response = await api.getReviewStats()
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export const useCouponStats = () => {
  return useQuery({
    queryKey: ['dashboard', 'coupon-stats'],
    queryFn: async () => {
      const response = await api.getCouponStats()
      return response.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
